import React from "react";
import Paper from "@material-ui/core/Paper";
import ReservationInputsForm from "./ReservationInputsForm";
import Style from "../../styles/js/StyleReservations.js";
import Typography from "@material-ui/core/Typography";
import * as ScreenText from "../../consts/ScreenText.js";

export default function ReservationForm({
  state,
  handleChange,
  handleSubmit,
  errors,
}) {
  const style = Style();

  return (
    <Paper className={style.reservationsForm}>
      <Typography variant="h4" gutterBottom>
        {ScreenText.RESERVATION_TITLE}
      </Typography>
      <ReservationInputsForm
        state={state}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
      <Typography variant="caption" gutterBottom>
        {ScreenText.RESERVATION_SEARCH_MESSAGE}
      </Typography>
      <Typography variant="caption" gutterBottom>
        {ScreenText.RESERVATION_EXPORT_MESSAGE}
      </Typography>
    </Paper>
  );
}
